import * as React from "react"

function SvgComponent(props) {
	return (
		<svg width="24px" height="24px" viewBox="0 0 24 24" {...props}>
			<g fill="none" fillRule="evenodd">
				<path d="M0 0H24V24H0z" />
				<path
					d="M12 21a9 9 0 110-18 9 9 0 010 18zm0-3a6 6 0 100-12 6 6 0 000 12z"
					fill="#000"
				/>
				<path d="M12 16a4 4 0 100-8 4 4 0 000 8z" fill="#000" opacity={0.3} />
			</g>
		</svg>
	)
}

export default React.memo(SvgComponent)